import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Product} from "../../models/product";

@Injectable()
export class SearchEventsService {


    private SearchTriggered = new Subject<string>();

    public searchTriggeredEvent = this.SearchTriggered.asObservable();

    EmitSearchTriggeredEvent(keyword) {

        this.SearchTriggered.next(keyword);
    }


}
